import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoHome } from "react-icons/io5";
import { FaCircleInfo } from "react-icons/fa6";
import { SiMaplibre } from "react-icons/si";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import SignIn from "../../components/SignIn";
import { useAuth } from "../../services/AuthContext";
import Swal from "sweetalert";
import { userLogOut } from "../../api/fetch";

const Navbar = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  const { customerUser, setCustomerUser, isSignInOpen, setIsSignInOpen } =
    useAuth();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    // Check if user has visited before
    if (!localStorage.getItem("visited")) {
      localStorage.setItem("visited", "true");
      setIsSignInOpen(true);
    }
  }, [isSignInOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLogout = async () => {
    const authToken = localStorage.getItem("userToken");

    try {
      const res = await userLogOut(authToken);

      if (res?.status) {
        localStorage.removeItem("userToken");
        setCustomerUser(null);
        navigate("/");
        Swal({
          title: "Logged out successfully!",
          icon: "success",
          timer: 1000,
        });
      }
    } catch (error) {
      console.log("Error ::", error);
    }
  };

  return (
    <nav className="bg-gray-800 text-white p-4 py-3 font-Poppins">
      {/* Container */}

      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <div className="md:hidden lg:hidden text-2xl font-bold">
          <Link to="/" className="text-yellow-400 hover:text-yellow-500">
            Taxica India
          </Link>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8 items-center">
          <Link
            to="/"
            className={`font-medium text-lg flex items-center space-x-2 ${
              isActive("/") ? "text-yellow-400" : "hover:text-yellow-400"
            }`}
          >
            <IoHome size={"20"} className="inline mr-1" />
            HOME
          </Link>
          <Link
            to="/AboutUs"
            className={`font-medium text-lg flex items-center space-x-2 ${
              isActive("/AboutUs") ? "text-yellow-400" : "hover:text-yellow-400"
            }`}
          >
            <FaCircleInfo size={"20"} className="inline mr-1" />
            ABOUT
          </Link>
          <Link
            to="/ContactUs"
            className={`font-medium text-lg flex items-center space-x-2 ${
              isActive("/ContactUs")
                ? "text-yellow-400"
                : "hover:text-yellow-400"
            }`}
          >
            <SiMaplibre size={"20"} className="inline mr-1" />
            CONTACT
          </Link>
        </div>

        {/* Profile or Get Started Button */}
        <div className="hidden md:flex items-center">
          {!customerUser ? (
            <Link
              to="#"
              onClick={() => setIsSignInOpen(true)}
              alt="starteddd"
              className="relative inline-block bg-yellow-400 text-gray-800 px-8 py-4 font-Poppins text-md rounded-full font-medium overflow-hidden group transition-colors duration-300"
            >
              <span className="absolute inset-0 bg-gray-800 rounded-full transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-in-out"></span>
              <span className="relative z-10 transition-colors duration-300 group-hover:text-yellow-400">
                GET STARTED
              </span>
            </Link>
          ) : (
            <div className="flex items-center space-x-4">
              <img
                src={customerUser?.avatar || "./assets/logo.png"}
                alt="User Avatar"
                className="w-10 h-10 rounded-full border-2 border-yellow-400 cursor-pointer"
              />
              <button
                onClick={handleLogout}
                className="text-yellow-400 hover:text-yellow-500 font-medium"
              >
                Logout
              </button>
            </div>
          )}
        </div>

        {/* Mobile Menu Icon */}
        <button
          className="md:hidden text-white text-2xl focus:outline-none"
          onClick={toggleMobileMenu}
        >
          {isMobileMenuOpen ? <AiOutlineClose /> : <AiOutlineMenu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden mt-4 space-y-4 bg-gray-700 p-4 rounded-lg">
          <Link
            to="/"
            className={`block font-medium text-lg ${
              isActive("/") ? "text-yellow-400" : "hover:text-yellow-400"
            }`}
            onClick={toggleMobileMenu}
          >
            <IoHome size={"20"} className="inline mr-2" />
            HOME
          </Link>
          <Link
            to="/AboutUs"
            className={`block font-medium text-lg ${
              isActive("/AboutUs") ? "text-yellow-400" : "hover:text-yellow-400"
            }`}
            onClick={toggleMobileMenu}
          >
            <FaCircleInfo size={"20"} className="inline mr-2" />
            ABOUT
          </Link>
          <Link
            to="/ContactUs"
            className={`block font-medium text-lg ${
              isActive("/ContactUs")
                ? "text-yellow-400"
                : "hover:text-yellow-400"
            }`}
            onClick={toggleMobileMenu}
          >
            <SiMaplibre size={"20"} className="inline mr-2" />
            CONTACT
          </Link>
          {/* <Link
            to="#"
            className="block text-center bg-yellow-400 text-gray-800 px-6 py-2 font-medium rounded-full hover:bg-yellow-500 transition-colors duration-300"
          >
            GET STARTED
          </Link> */}
        </div>
      )}

      {!customerUser && (
        <SignIn isOpen={isSignInOpen} onClose={() => setIsSignInOpen(false)} />
      )}
    </nav>
  );
};

export default Navbar;
